import { buildOrderItemUrl } from '@functions/orderItem'

import useOrder from '@hooks/useOrder'
import useSelector from '@hooks/useSelector'

import type { OrderModel, UserModel } from '@models/types'

import CompactListOrderItem from '../CompactListOrderItem'
import LargeListOrderItem from '../LargeListOrderItem'

interface OrderProps {
  canManageOrders: boolean,
  currentUser: UserModel,
  displayMode: string,
  isCampaignManager?: boolean,
  order: OrderModel,
}

const Order = (props: OrderProps) => {
  const {
    canManageOrders, currentUser, displayMode, isCampaignManager, order,
  } = props

  const { items = [] } = order

  const useOrderPayload = useOrder(order)
  // @ts-expect-error TS2339
  const { status } = useOrderPayload

  const orderItems = useSelector(reduxState => reduxState.entities.orderItems)

  const ListComponent = displayMode === 'compact-list' ? CompactListOrderItem : LargeListOrderItem

  return items?.map((orderItemId: number) => {
    const orderItem = orderItems[orderItemId]

    if (!orderItem) return null

    return (
      <ListComponent
        currentUser={currentUser}
        // @ts-expect-error TS2322
        isCampaignManager={isCampaignManager}
        key={orderItemId}
        orderItem={orderItem}
        useOrderPayload={useOrderPayload}
        url={canManageOrders ? buildOrderItemUrl({ order, orderItem, status }) : ''}
      />
    )
  })
}

export default Order
